module.exports = __webpack_public_path__ + "img/ic_yifukuan.6caf233a.svg";